module.exports = __webpack_public_path__ + "static/media/GothamBook.56f46dad.woff";